import React, {Component} from 'react';
import {Tooltip} from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { Link, Element } from 'react-scroll';
import {Cookies} from 'react-cookie';
import _ from 'lodash';
import {Helmet} from 'react-helmet';

import LearnMore from '../../components/Forms/LearnMore';
import ReasonsResults from '../../components/Reasons/ReasonsResults';
import iconChecks from '../../assets/svg/icon-checks.svg';
import CustomerConnect from '../../components/CustomerConnect/CustomerConnect.jsx';
import getOpenEnrollmentDates from '../../helpers/openEnrollment';
import ScrollButton from '../../components/Header/ScrollButton.jsx';
import * as ResultHelpers from '../../helpers/results';
import * as RouteHelpers from '../../helpers/routes';
import { encodeUrl } from '../../helpers/quiz';

class Results extends Component {
  state = {
    fieldValues: {},
    result: {},
    data: {},
    plans: [],
    selectedPlan: [],
    selectedPlanID: '',
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/individual`,
    formResults: this.props.quiz.fieldValues,
    showModal: false,
    includeChildHealthPlus: false,
    plansInRegion: [],
    FamilyType: this.props.quiz.fieldValues.FamilyType,
    mounted: false,
    headerHeight: 100,
    animateChangePrice: false,
    planOrderPremium: false,
    trackOnce: true
  };

  getHeaderHeight = (height) => {
    this.setState({headerHeight: height});
  };

  // Get Initial Plan Data
  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': 'Results'});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.updateHeaderPhone('866-692-3747');
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.reducer({fieldValues: p.quiz.fieldValues, url: 'individual'});
      p.updateResultsFooter(true, {
        'jdpower': 'true',
        'results': 'true'
      });
      p.updateResultsRatings(true, {
        'jdpower': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Me'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
      this.getHeaderHeight(document.querySelector('#template > article > header').scrollHeight + 150);
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {quiz, rest} = p;
    const {fieldValues} = quiz;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length) {
      let result, selectedPlan;

      if (rest.quote.hasOwnProperty('IsEssentialEligible') && rest.quote.IsEssentialEligible) {
        result = selectedPlan = rest.quote.PlanEssential;
      } else if (!_.isUndefined((rest.quote)) || !_.isUndefined((rest.quote.Plans))) {
        result = rest.quote;
        selectedPlan = result.Plans.find((obj) => (obj.PlanId === result.SelectedPlanId));
      }

      const planOrderPremium = rest.quote.planOrderPremium;
      const planOrderMax = rest.quote.planOrderMax;
      const planOrderDeductible = rest.quote.planOrderDeductible;
      let {lastSelectedPlanId} = _.clone(state);
      const {Subsidy} = rest.quote;

      let monthlyDollars = '';
      let monthlyCents = '';
      let oopMaxAmount;

      let {FamilyType} = _.clone(quiz.fieldValues.FamilyType);
      let showCHP = null;

      if (result) {
        showCHP = (result.ChpIsSubsidized === true && fieldValues.KidsCount > 0);
        if (showCHP) {
          if (fieldValues.FamilyType === 'IndividualChildren') {
            FamilyType = 'Individual';
          } else {
            FamilyType = 'Couple';
          }
        } else {
          FamilyType = fieldValues.FamilyType;
        }
      }

      let deductible;
      let deductibleAmount;
      let premiums = ResultHelpers.getPremiumsForResult({
        'premium': planOrderPremium,
        'deductible': planOrderDeductible,
        'famType': FamilyType,
        'max': planOrderMax,
        'result': selectedPlan,
        Subsidy
      });

      let {
        annualDeductible,
        highestDeductible,
        highestMax,
        highestPremium,
        lowestDeductible,
        lowestMax,
        lowestPremium,
        monthlyPremium,
        oopmax
        // welcome
      } = premiums;

      let calculateCHP = null;
      let chpNotice = null;
      let numberOfKids = fieldValues.KidsCount;
      let childLang = null;
      let childLang02 = null;
      let chpTotal = (numberOfKids * result.ChpCostPerChild);
      let chpMax = result.ChpSubsidizedMax;
      let monthlyCHP = null;
      let originalFamilyType = fieldValues.FamilyType;
      let enrollCHP;
      let welcomeEssential;
      let showSubsidy = null;

      if (Subsidy > 0) {
        showSubsidy = (
          <p className='desc'>
            <em>Includes estimated savings of ${Subsidy.toFixed(2)}/month based on your income.</em>
          </p>
        );
      }

      if (chpTotal < chpMax) {
        monthlyCHP = chpTotal;
      } else {
        monthlyCHP = chpMax;
      }

      if (showCHP) {
        if (originalFamilyType === 'IndividualChildren') {
          FamilyType = 'IndividualChildren';
        }
        if (numberOfKids === 1) {
          childLang = 'child is';
          childLang02 = 'child';
        } else {
          childLang = 'children are';
          childLang02 = 'children';
        }
        chpNotice = <strong>Your {numberOfKids} {childLang} eligible for Child Health Plus:</strong>;

        calculateCHP = (
          <span> ${monthlyCHP}/month with no additional costs.<br /> Call <a href='tel:866-692-3747' className='tel'>866-692-3747</a> or <Link
            to='learnForm' spy smooth={'easeInOutQuart'}
            duration={800}
            offset={-200}>complete the form</Link> to learn more or enroll any time.</span>);
        enrollCHP = <span className='copy'>You can enroll your {childLang02} in <strong>Child Health Plus</strong> at any time.</span>;
      }

      // Essential Plan Callout
      let essentialNotice = null;
      let newMonthlyRate = null;
      let newMonthlyRateNum = null;

      const showEssential = (fieldValues.KidsCount === '0' && (originalFamilyType === 'IndividualChildren' ||
        originalFamilyType === 'CoupleChildren'));

      if (planOrderPremium) {
        if (showEssential) {
          if (originalFamilyType === 'IndividualChildren') {
            welcomeEssential = 'you';
            newMonthlyRateNum = selectedPlan.MonthlyIndividualPremium - Subsidy;
            newMonthlyRate = ResultHelpers.numberWithCommas(newMonthlyRateNum.toFixed(2));
          } else {
            welcomeEssential = 'you and your spouse';
            newMonthlyRateNum = selectedPlan.MonthlyCouplePremiumSelfSpouse - Subsidy;
            newMonthlyRate = ResultHelpers.numberWithCommas(newMonthlyRateNum.toFixed(2));
          }

          essentialNotice = (
            <span>
              <strong>Potential Cost Saving Tip:</strong>
              Children over age 19 may be eligible for a free or low cost
              <a href='/essential'>Essential plan</a>, reducing the monthly fee to as low as
              <strong>${newMonthlyRate}</strong> on a plan for just {welcomeEssential}. Call
              <a
                href='tel:866-692-3747'
                className='tel'
              >866-692-3747</a> for help deciding.
            </span>
          );
        }
      }

      // Add to Monthly Premium
      if (state.includeChildHealthPlus) {
        if (chpTotal < chpMax) {
          monthlyPremium = monthlyPremium + chpTotal;
        } else {
          monthlyPremium = monthlyPremium + chpMax;
        }
      }

      // Monthly Premiums, split whole amount and decimals for display
      if (!_.isUndefined(monthlyPremium)) {
        if (monthlyPremium < 0) {
          monthlyDollars = '0';
          monthlyCents = '.00';
        } else {
          const monthlyPremiumString = monthlyPremium.toFixed(2).toString();
          monthlyDollars = monthlyPremiumString.slice(0, -3);
          monthlyCents = monthlyPremiumString.slice(-3);
        }
      }

      if (lowestPremium) {
        if (lowestPremium < 0) {
          lowestPremium = '0.00';
        }
      }

      if (result && !_.isUndefined(selectedPlan)) deductible = selectedPlan.HasDeductible;
      deductibleAmount = annualDeductible ? ResultHelpers.numberWithCommas(annualDeductible) : '0';
      oopMaxAmount = oopmax ? ResultHelpers.numberWithCommas(oopmax) : '';

      let discount = 'CDPHP Discounted Price';
      const discountContent = (<span>
        <p>CDPHP has negotiated reduced rates for most doctor and hospital visits to save you money. For example:</p>
        <ul>
          <li>
            <strong>MRI</strong><br />
            <span>Without insurance: <strong>$4,500</strong></span><br />
            <span className='green'>With CDPHP: <strong>$738</strong></span>
          </li>
          <li>
            <strong>Fractured Ankle</strong><br />
            <span>Without insurance: <strong>$7,800</strong></span><br />
            <span className='green'>With CDPHP: <strong>$2,869</strong></span>
          </li>
        </ul>
      </span>);
      const discountToolTip = <Tooltip html={discountContent} arrow='true' unmountHTMLWhenHide='true'>the <strong
        className='helpTip'>CDPHP Discounted Price</strong></Tooltip>;

      // Send Location Through
      const cookies = new Cookies();
      let Loc = _.clone(props.quiz.location);
      if (cookies.get('CDPHP_myResults')) {
        Loc = cookies.get('CDPHP_myResults').Location;
      }

      // const contentPadding = state.headerHeight - 110;
      // let contentStyling = {paddingTop: contentPadding + 'px'};
      let contentStyling;

      const animatePrice = state.animateChangePrice ? 'animatePrice active' : 'animatePrice';

      let mobileBefore = deductible ? <p className='mobile'>Before <span>${deductibleAmount} in Expenses</span></p> : '';
      let mobileAfter = deductible ?
        <p className='mobile'>After <span>${deductibleAmount} in Expenses</span></p> :
        <p className='mobile'>You Pay This Portion</p>;

      if (lastSelectedPlanId !== rest.quote.SelectedPlanId) {
        if (state.trackOnce === true) {
          ResultHelpers.sendAnalyticsOnQuote(fieldValues, rest);
        }

        const headerPremium = (
          <h5 key={monthlyDollars + monthlyCents} className={'price'}>
            <strong key={monthlyDollars + monthlyCents}>
              ${ResultHelpers.numberWithCommas(monthlyDollars)}<sup
              >{monthlyCents}</sup></strong> /Month</h5>
        );
        lastSelectedPlanId = rest.quote.SelectedPlanId;
        props.updateHeaderPremium(headerPremium);
      }

      let introTarget;
      switch (FamilyType) {
        case 'Individual':
          introTarget = 'you.';
          break;
        case 'IndividualChildren':
          introTarget = 'you.';
          break;
        case 'Couple':
          introTarget = <span className='break'>you and your spouse.</span>;
          break;
        case 'CoupleChildren':
          introTarget = <span className='break'>you and your family.</span>;
          break;
      }

      // set state once we have data from the server on the selected plan:
      return {
        result,
        lastSelectedPlanId,
        oopMaxAmount,
        discount,
        discountToolTip,
        Loc,
        highestDeductible,
        highestMax,
        lowestPremium,
        highestPremium,
        lowestDeductible,
        lowestMax,
        showCHP,
        calculateCHP,
        chpNotice,
        enrollCHP,
        showSubsidy,
        // welcome,
        essentialNotice,
        animatePrice,
        mobileBefore,
        mobileAfter,
        contentStyling,
        monthlyDollars,
        monthlyCents,
        introTarget,
        deductible,
        deductibleAmount,
        plans: rest.quote.Plans,
        selectedPlan,
        selectedPlanID: rest.quote.SelectedPlanId,
        loading: false,
        fieldValues,
        formResults: fieldValues,
        planOrderPremium: rest.quote.planOrderPremium,
        planOrderDeductible: rest.quote.planOrderDeductible,
        planOrderMax: rest.quote.planOrderMax,
        Subsidy: rest.quote.Subsidy,
        trackOnce: false
      };
    }

    return null; // if no state mutations are required at this time
  }

  // Create Cookie Here
  setCookie = (data) => {
    const cookies = new Cookies();
    cookies.set('CDPHP_myResults', data, {path: '/'});
  };

  changePlan = (planOrder, direction, type) => {
    const plans = planOrder;
    const currentPlanId = this.state.selectedPlanID;
    const currentPlan = plans.find(function (obj) {
      return obj.PlanId === currentPlanId;
    });
    let i = plans.indexOf(currentPlan);
    let nextPlan = null;
    let limit = null;
    let direc = null;

    if (direction === 'inc') {
      nextPlan = plans[i + 1];
      limit = (i === (plans.length - 1));
      direc = 'Increase';
    } else {
      nextPlan = plans[i - 1];
      limit = (i === 0);
      direc = 'Decrease';
    }

    if (!limit) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Change',
        'eventAction': 'Results',
        'eventLabel': direc + ' ' + type,
        'eventValue': undefined
      });

      this.setState({
        animateChangePrice: true
      });

      setTimeout(
        function () {
          this.props.changeSelectedPlan(nextPlan);
          this.setState({
            animateChangePrice: false
          });
        }.bind(this), 750
      );
    }
  };

  checkDate = () => {
    return getOpenEnrollmentDates();
  }

  render () {
    const s = _.clone(this.state);
    const {
      result,
      showEssential,
      deductibleAmount,
      deductible,
      oopMaxAmount,
      discount,
      discountToolTip,
      Loc,
      highestDeductible,
      highestMax,
      lowestPremium,
      highestPremium,
      lowestDeductible,
      lowestMax,
      showCHP,
      calculateCHP,
      chpNotice,
      // enrollCHP,
      showSubsidy,
      // welcome,
      essentialNotice,
      animatePrice,
      mobileBefore,
      mobileAfter,
      contentStyling,
      showModal,
      selectedPlan,
      planOrderPremium,
      planOrderDeductible,
      planOrderMax,
      Subsidy,
      fieldValues,
      monthlyDollars,
      monthlyCents,
      introTarget
    } = s;

    if (s.loading || !result || _.isUndefined(selectedPlan)) {
      return <div className={'dark loading'} />;
    }

    // if (_.isUndefined(this.props.page.header.topBanner) || _.isNull(this.props.page.header.topBanner)) {
    //   this.props.updateTopBanner(this.checkDate());
    // }

    const lowerPremiumDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderPremium) ||
      (s.selectedPlan.PlanId === s.planOrderPremium[0].PlanId);
    const higherPremiumDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderPremium) ||
      (s.selectedPlan.PlanId === s.planOrderPremium[s.planOrderPremium.length - 1].PlanId);

    const lowerDeductibleDisabled = _.isUndefined(s.planOrderDeductible) || _.isUndefined(s.planOrderDeductible) ||
      (s.selectedPlan.PlanId === s.planOrderDeductible[0].PlanId);
    const higherDeductibleDisabled = _.isUndefined(s.planOrderDeductible) || _.isUndefined(s.planOrderDeductible) ||
      (s.selectedPlan.PlanId === s.planOrderDeductible[s.planOrderDeductible.length - 1].PlanId);

    const lowerMaxDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderMax) ||
      (s.selectedPlan.PlanId === s.planOrderMax[0].PlanId);
    const higherMaxDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderMax) ||
      (s.selectedPlan.PlanId === s.planOrderMax[s.planOrderMax.length - 1].PlanId);

    return (
      <div className={'dark ' + (s.loading ? 'loading' : '') + (showModal ? ' modal-open' : '')}>
        <Helmet>
          <title>Your CDPHP Plan Quote</title>
        </Helmet>

        {showEssential ?
          <section className='chp-callout enrollment'>
            <div className='wrap sm'>
              <div className='container'>
                {essentialNotice}
              </div>
            </div>
          </section> : null}

        {showCHP ?
          <section className='chp-callout enrollment'>
            <div className='wrap sm'>
              <div className='container'>
                {chpNotice}{calculateCHP}
              </div>
            </div>
          </section> : null}

        <section id='intro' className='pb60' style={contentStyling}>
          <div className='wrap'>
            <h1>We have just the plan&nbsp;for&nbsp;{introTarget}</h1>
            <h3>We recommend the <strong>{selectedPlan.PlanName}</strong>&nbsp;plan.</h3>
          </div>
        </section>

        <section className=''>
          <div className='wrap sm'>
            <div className='container'>
              <img src={iconChecks} className='checks' alt='' />
              <ul className={'bullets ' + animatePrice}>
                <li>{selectedPlan.PlanDescriptor1}</li>
                <li>{selectedPlan.PlanDescriptor2}</li>
                <li>{selectedPlan.PlanDescriptor3}</li>
              </ul>
              <div className='navigate'>
                <div className={animatePrice}>
                  <h3 className={showSubsidy || calculateCHP ? '' : 'middle'}
                  >The
                    <Tooltip
                      title='This is your “Premium.” It’s the price you pay for ongoing insurance coverage.' arrow='true'
                    >
                      <span
                        className='helpTip'
                      > monthly fee </span>
                    </Tooltip> is
                    <strong> ${ResultHelpers.numberWithCommas(monthlyDollars)}
                      <sup>{monthlyCents}*</sup>
                    </strong>
                  </h3>
                  {showSubsidy}
                </div>

                <nav>
                  <a
                    onClick={() => this.changePlan(planOrderPremium, 'dec', 'Premium')}
                    className={'lower ' + (lowerPremiumDisabled ? 'disabled' : '')}
                  >
                    <strong className='btn alt'>–</strong>
                    <span>Options as low<br /> as ${lowestPremium}</span>
                  </a>
                  <a
                    onClick={() => this.changePlan(planOrderPremium, 'inc', 'Premium')}
                    className={'higher ' + (higherPremiumDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>+</strong>
                    <span>Options as high<br /> as ${highestPremium}</span>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <ReasonsResults
          search='https://findadoc.cdphp.com/?PlanType=New York State of Health - Individuals & Families' />

        <section>
          <div className='wrap sm'>
            <div className='container'>
              <div className='navigate expenses'>
                <div className={animatePrice}>
                  <h4>You’re responsible for
                    <Tooltip
                      title='This is your “Deductible” It’s the amount you’re required to pay out of pocket toward medical care each year before your plan begins to pay.'
                      arrow='true'
                    >
                      <span className='helpTip'>
                        <strong> ${deductibleAmount}</strong> in medical expenses
                      </span>
                    </Tooltip> before the plan helps you pay, plus a portion of the bills after that.
                  </h4>
                </div>

                <nav>
                  <a
                    onClick={() => this.changePlan(planOrderDeductible, 'dec', 'Deductible')}
                    className={'lower ' + (lowerDeductibleDisabled ? 'disabled' : '')}
                  >
                    <strong className='btn alt'>–</strong>
                    <span>Options as low<br /> as ${lowestDeductible}</span>
                  </a>

                  <a
                    onClick={() => this.changePlan(planOrderDeductible, 'inc', 'Deductible')}
                    className={'higher ' + (higherDeductibleDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>+</strong>
                    <span>Options as high<br /> as ${highestDeductible}</span>
                  </a>
                </nav>
                {deductible ?
                  <p className='info text-center'>Feel too pricey? You can reduce this cost, but your monthly payment
                    will increase.</p> :
                  <p className='info text-center'>Willing to pay more? You can increase this cost to reduce your monthly
                    payment.</p>
                }
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className='wrap sm'>
            <div className='results container'>
              <div className='table'>
                <table className={deductible ? '' : 'noDeductible'}>
                  <thead>
                    <tr className='heading'>
                      <th className='item'><h4>Plan Benefits</h4></th>
                      <th className='before'>{deductible ?
                        <h4>Before <span>${deductibleAmount} in Expenses</span></h4> : ''}</th>
                      <th className='after'>
                        {deductible ?
                          <h4>After <span>${deductibleAmount} in Expenses</span></h4> :
                          <h4>You Pay This Portion</h4>
                        }
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr className='alt'>
                      <td className='item'>
                        <Tooltip
                          interactive='true'
                          html={(
                            <span>
                              With Enhanced Primary Care, the entire practice functions as your medical home – a place where doctors, nurse practitioners, and administrative staff provide the support you need to stay healthy. That means more one-on-one time with your doctor, better coordination of care, and higher-quality health outcomes.
                              <a
                                href='https://findadoc.cdphp.com'
                                target='_blank'
                                rel='noopener noreferrer'
                              >Search for a participating enhanced primary care provider in your area</a>.
                            </span>
                          )}
                          arrow='true'>
                          <h5 className='helpTip'>Enhanced Primary Care Visits</h5>
                        </Tooltip></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.EnhancedPrimaryCareVisitsPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.EnhancedPrimaryCareVisitsPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You
                        pay <strong>{selectedPlan.EnhancedPrimaryCareVisitsPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Primary Care Visits</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.PcpVisitPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.PcpVisitPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.PcpVisitPostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Specialist Doctor Visits</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.SpecialistVisitPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.SpecialistVisitPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.SpecialistVisitPostDeductible}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Hospital Stays</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.InpatientHospitalStaysPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.InpatientHospitalStaysPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You
                        pay <strong>{selectedPlan.InpatientHospitalStaysPostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Surgery</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.SurgeryPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.SurgeryPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.SurgeryPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Urgent Care</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.UrgentCarePreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.UrgentCarePreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.UrgentCarePostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Emergency Room</h5></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.EmergencyRoomPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.EmergencyRoomPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.EmergencyRoomPostDeductible}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className='item'><Tooltip
                        title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.'
                        arrow='true'><h5 className='helpTip'>Prescription Drugs</h5></Tooltip></td>
                      <td className='before'>{mobileBefore}{deductible ?
                        <span>You pay {selectedPlan.PrescriptionsPreDeductible === discount ? discountToolTip : (
                          <strong>{selectedPlan.PrescriptionsPreDeductible}</strong>)}</span> : ''}</td>
                      <td className='after'>{mobileAfter}You pay <strong>{selectedPlan.PrescriptionsPostDeductible}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='navigate'>
                <div className={animatePrice}>
                  <h4>That’s it! Once you’ve paid a total of <Tooltip
                    title='This is your “Out of Pocket Maximum.” It’s the most you’ll have to pay for covered health services in a plan year.'
                    arrow='true'><span className='helpTip'><strong className='price'>${oopMaxAmount}</strong> toward your bills</span></Tooltip>,
                    CDPHP covers everything through the end of the year.</h4>
                </div>

                <nav>
                  <a
                    onClick={() => this.changePlan(planOrderMax, 'dec', 'OOP Max')}
                    className={'lower ' + (lowerMaxDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>–</strong>
                    <span>Options as low<br /> as ${lowestMax}</span>
                  </a>

                  <a
                    onClick={() => this.changePlan(planOrderMax, 'inc', 'OOP Max')}
                    className={'higher ' + (higherMaxDisabled ? 'disabled' : '')}
                  >
                    <strong className='btn alt'>+</strong>
                    <span>Options as high<br /> as ${highestMax}</span>
                  </a>
                </nav>
                <p className='info text-center'>Even in the event of a serious medical issue, you’ll never pay more than
                  this in<br /> a calendar year—as long as you see the doctors and hospitals in our plan.</p>
              </div>
            </div>
          </div>
        </section>

        <Element name='learnForm'>
          <LearnMore
            planName={selectedPlan.PlanName}
            area='IndividualQuote'
            closeModal={this.closeModalHandler}
            show={showModal}
            details={fieldValues}
            lastPlanId={selectedPlan.PlanId}
            subsidy={Subsidy}
            Location={Loc}
            phone='866-692-3747' />
        </Element>

        <section className='contact'>
          <div className='wrap sm text-center'>
            <h5>We&rsquo;re here to help.</h5>
            <div>
              Call us at <a href='tel:866-692-3747' className='tel phoneswap'>866-692-3747</a>
              {Loc && Loc.loc && <CustomerConnect zip={Loc.loc.Zip} />}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Results;
